import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'convertDesodorante'
})
export class ConvertDesodorantePipe implements PipeTransform {

  transform(value: any, args?: any): any {
    switch (value) {
      case  5:
        return 'Creme';
      case  6:
        return  'Spray';
      case  7:
        return 'Bastão';
      case  8:
        return 'Roll-on';
      case  9:
        return 'Aerossol';
      case  16:
        return args;
    }
  }

}
